// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#content {
  flex: 1;
  padding: 30px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  color: #373643;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.contentHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-family: 'HeroLight', sans-serif;
  width: 90%;
}

.contentHead h1 {
  font-size: 26px;
  font-weight: 500;
  color: #373643;
  text-transform: capitalize;
}

.contentHead option {
    border: none;
}

.contentHead select {
  font-family: 'Poppins', sans-serif;
  padding: 8px 12px;
  font-size: 14px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border: 1px solid #ccc;
  background-color: #fff;
  color: #373643;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.contentHead select:hover {
    border-top-color: #18cb96;
    border-right-color: #18cb96;
    border-left-color: #18cb96;
}

.contentHead select:focus {
    outline: none;
    border-top-color: #18cb96;
    border-right-color: #18cb96;
    border-left-color: #18cb96;
}

.contentHead option {
    font-size: 12px;
}

.progress {
  margin-bottom: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 25px;
  color: #18cb96;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-progress {
    font-size: 30px;
    color: #373643;
    text-align: center;
}

.taskCard {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-left: 5px solid #18cb96;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: grid;
  grid-template-columns: 1fr 9fr 3fr;
  align-items: center;
  justify-content: center;
  column-gap: 15px;
  max-width: 450px;
}

.taskCard:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
}

.taskCard h3 {
  margin: 0 0 6px;
  font-size: 18px;
  color: #373643;
  font-weight: 600;
  grid-column: 2/3;
}

.taskCard p {
  margin: 4px 0;
  font-size: 14px;
  color: #666;
}

.taskDesc {
    grid-column: 2/3;
    grid-row: 2/3;
    align-self: flex-start;
    overflow-x: hidden; 
}

.projectName {
    grid-column: 2;
    grid-row: 3;
    text-align: left;
    padding: 8px 32px;
    background-color: #464555;
    border-radius: 15px;
    overflow-x: hidden;
    width: max-content;
    cursor: pointer;
}

.projectName:hover {
    background-color: #373643;
}

.taskSection {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    column-gap: 10px;
    width: 100%;
}

.taskDueDate {
    grid-column: 3/4;
    grid-row: 1;
    text-align: right;
}

.taskCard > .priority-high {
  background-color: #ff4d4d;
  color: white;
}

.taskCard > .priority-medium {
  background-color: #ffc107;
  color: #333;
}

.taskCard > .priority-low {
  background-color: #18cb96;
  color: white;
}

.deleteBtn img, .editBtn img, .statusBtn img {
    width: 100%;
}

.deleteBtn, .editBtn, .statusBtn {
    width: 25px;
    display: flex;
    padding: 5px;
    background-color: #ffffff;
    margin-top: 8px;
    border-radius: 4px;
    grid-column: 1/2;
    cursor: pointer;
}

.statusBtn {
    grid-row: 2;
}

.deleteBtn {
    grid-row: 3;
}

.priority {
    grid-column: 3/4;
    grid-row: 3/4;
    text-align: center;
    padding: 5px 15px;
    border-radius: 5px;
}

.priority-project {
    grid-column: 2/4;
}

.editBtn {
    grid-row: 1;
}

.completed {
  color: #18cb96;
  font-weight: bold;
}

.incomplete {
  color: #999;
}

@media (max-width: 500px) {
    #content {
        padding: 5%;
    }
    .contentHead {
        flex-direction: column;
    }
    .progress {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }
    .progress p {
        margin: 0;
    }
    .taskCard {
        grid-template-columns: 100px 100px 30px;
        padding: 4px 8px;
        border-left: 4px solid #18cb96;
    }
    .taskSection {
        justify-content: center;
        align-items: center;
    }
    .taskCard h3 {
        grid-column: 1/4;
        grid-row: 1;
        font-size: 16px;
    }
    .deleteBtn, .editBtn, .statusBtn {
        grid-row: 5;
    }
    .statusBtn {
        grid-column: 1;
    }
    .editBtn {
        grid-column: 2;
    }
    .deleteBtn {
        grid-column: 3;
    }
    .priority-project {
        grid-column: 2/3;
    }
    .taskDesc {
        grid-column: 1/4;
        grid-row: 2;
        font-size: 12px !important;
    }
    .taskDueDate {
        grid-row: 1;
        grid-column: 3;
        font-size: 12px !important;
    }
    .projectName {
        grid-column: 1;
        grid-row: 3;
        padding: 5px 15px;
        font-size: 13px !important;
    }
    .priority {
        grid-column: 2;
        grid-row: 3;
        padding: 5px 15px;
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/filter/filter.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;EACtC,qDAAqD;EACrD,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,SAAS;IACb;IACA;QACI,uCAAuC;QACvC,gBAAgB;QAChB,8BAA8B;IAClC;IACA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,cAAc;QACd,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":["#content {\r\n  flex: 1;\r\n  padding: 30px;\r\n  background-color: #f9f9f9;\r\n  transition: all 0.3s ease;\r\n  color: #373643;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.contentHead {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  font-family: 'HeroLight', sans-serif;\r\n  width: 90%;\r\n}\r\n\r\n.contentHead h1 {\r\n  font-size: 26px;\r\n  font-weight: 500;\r\n  color: #373643;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.contentHead option {\r\n    border: none;\r\n}\r\n\r\n.contentHead select {\r\n  font-family: 'Poppins', sans-serif;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n  border-top-left-radius: 6px;\r\n  border-top-right-radius: 6px;\r\n  border: 1px solid #ccc;\r\n  background-color: #fff;\r\n  color: #373643;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.contentHead select:hover {\r\n    border-top-color: #18cb96;\r\n    border-right-color: #18cb96;\r\n    border-left-color: #18cb96;\r\n}\r\n\r\n.contentHead select:focus {\r\n    outline: none;\r\n    border-top-color: #18cb96;\r\n    border-right-color: #18cb96;\r\n    border-left-color: #18cb96;\r\n}\r\n\r\n.contentHead option {\r\n    font-size: 12px;\r\n}\r\n\r\n.progress {\r\n  margin-bottom: 20px;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-size: 25px;\r\n  color: #18cb96;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.empty-progress {\r\n    font-size: 30px;\r\n    color: #373643;\r\n    text-align: center;\r\n}\r\n\r\n.taskCard {\r\n  background-color: #ffffff;\r\n  border: 1px solid #e0e0e0;\r\n  border-left: 5px solid #18cb96;\r\n  border-radius: 8px;\r\n  padding: 16px 20px;\r\n  margin-bottom: 16px;\r\n  font-family: 'Poppins', sans-serif;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.03);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  display: grid;\r\n  grid-template-columns: 1fr 9fr 3fr;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 15px;\r\n  max-width: 450px;\r\n}\r\n\r\n.taskCard:hover {\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.06);\r\n}\r\n\r\n.taskCard h3 {\r\n  margin: 0 0 6px;\r\n  font-size: 18px;\r\n  color: #373643;\r\n  font-weight: 600;\r\n  grid-column: 2/3;\r\n}\r\n\r\n.taskCard p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.taskDesc {\r\n    grid-column: 2/3;\r\n    grid-row: 2/3;\r\n    align-self: flex-start;\r\n    overflow-x: hidden; \r\n}\r\n\r\n.projectName {\r\n    grid-column: 2;\r\n    grid-row: 3;\r\n    text-align: left;\r\n    padding: 8px 32px;\r\n    background-color: #464555;\r\n    border-radius: 15px;\r\n    overflow-x: hidden;\r\n    width: max-content;\r\n    cursor: pointer;\r\n}\r\n\r\n.projectName:hover {\r\n    background-color: #373643;\r\n}\r\n\r\n.taskSection {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    flex-wrap: wrap;\r\n    column-gap: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.taskDueDate {\r\n    grid-column: 3/4;\r\n    grid-row: 1;\r\n    text-align: right;\r\n}\r\n\r\n.taskCard > .priority-high {\r\n  background-color: #ff4d4d;\r\n  color: white;\r\n}\r\n\r\n.taskCard > .priority-medium {\r\n  background-color: #ffc107;\r\n  color: #333;\r\n}\r\n\r\n.taskCard > .priority-low {\r\n  background-color: #18cb96;\r\n  color: white;\r\n}\r\n\r\n.deleteBtn img, .editBtn img, .statusBtn img {\r\n    width: 100%;\r\n}\r\n\r\n.deleteBtn, .editBtn, .statusBtn {\r\n    width: 25px;\r\n    display: flex;\r\n    padding: 5px;\r\n    background-color: #ffffff;\r\n    margin-top: 8px;\r\n    border-radius: 4px;\r\n    grid-column: 1/2;\r\n    cursor: pointer;\r\n}\r\n\r\n.statusBtn {\r\n    grid-row: 2;\r\n}\r\n\r\n.deleteBtn {\r\n    grid-row: 3;\r\n}\r\n\r\n.priority {\r\n    grid-column: 3/4;\r\n    grid-row: 3/4;\r\n    text-align: center;\r\n    padding: 5px 15px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.priority-project {\r\n    grid-column: 2/4;\r\n}\r\n\r\n.editBtn {\r\n    grid-row: 1;\r\n}\r\n\r\n.completed {\r\n  color: #18cb96;\r\n  font-weight: bold;\r\n}\r\n\r\n.incomplete {\r\n  color: #999;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    #content {\r\n        padding: 5%;\r\n    }\r\n    .contentHead {\r\n        flex-direction: column;\r\n    }\r\n    .progress {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        font-size: 14px;\r\n    }\r\n    .progress p {\r\n        margin: 0;\r\n    }\r\n    .taskCard {\r\n        grid-template-columns: 100px 100px 30px;\r\n        padding: 4px 8px;\r\n        border-left: 4px solid #18cb96;\r\n    }\r\n    .taskSection {\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n    .taskCard h3 {\r\n        grid-column: 1/4;\r\n        grid-row: 1;\r\n        font-size: 16px;\r\n    }\r\n    .deleteBtn, .editBtn, .statusBtn {\r\n        grid-row: 5;\r\n    }\r\n    .statusBtn {\r\n        grid-column: 1;\r\n    }\r\n    .editBtn {\r\n        grid-column: 2;\r\n    }\r\n    .deleteBtn {\r\n        grid-column: 3;\r\n    }\r\n    .priority-project {\r\n        grid-column: 2/3;\r\n    }\r\n    .taskDesc {\r\n        grid-column: 1/4;\r\n        grid-row: 2;\r\n        font-size: 12px !important;\r\n    }\r\n    .taskDueDate {\r\n        grid-row: 1;\r\n        grid-column: 3;\r\n        font-size: 12px !important;\r\n    }\r\n    .projectName {\r\n        grid-column: 1;\r\n        grid-row: 3;\r\n        padding: 5px 15px;\r\n        font-size: 13px !important;\r\n    }\r\n    .priority {\r\n        grid-column: 2;\r\n        grid-row: 3;\r\n        padding: 5px 15px;\r\n        font-size: 13px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
